import { Checkbox, Chip, ListItemAvatar, ListItemButton, ListItemText, Stack, Typography } from '@mui/material';
import type { ListItemButtonProps } from '@mui/material';
import { EnlargeableAvatar } from '../../../components';

import type { JobHiringType } from './job_hirings_card_item';

export type JobHiringActionItemProps = {
  jobHiring: JobHiringType;
  tipAmount?: number;
  selected?: boolean;
} & ListItemButtonProps;

export const JobHiringActionItem = ({ jobHiring, selected, tipAmount, ...props }: JobHiringActionItemProps) => (
  <ListItemButton {...props}>
    <Checkbox edge="start" checked={selected} />
    <ListItemAvatar>
      <EnlargeableAvatar src={jobHiring.student.avatar ?? undefined} sx={{ width: 48, height: 48 }} />
    </ListItemAvatar>
    <ListItemText
      primary={
        <Stack flexDirection="row" alignItems="center" gap={0.5}>
          <Typography
            variant="body1"
            sx={{
              flex: 1,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitLineClamp: 1,
              WebkitBoxOrient: 'vertical',
              wordBreak: 'break-all',
            }}
          >
            เทมป์{jobHiring.student.nickName}
          </Typography>

          {tipAmount && (
            <Chip
              size="small"
              color="primary"
              label={
                <Typography variant="inherit" fontSize={11}>
                  ทิป {tipAmount}
                </Typography>
              }
            />
          )}
        </Stack>
      }
      secondary={`${jobHiring.student.firstName} ${jobHiring.student.lastName}`}
      secondaryTypographyProps={{
        sx: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: '-webkit-box',
          WebkitLineClamp: 1,
          WebkitBoxOrient: 'vertical',
          wordBreak: 'break-all',
        },
      }}
      sx={{ marginY: 0 }}
    />
  </ListItemButton>
);
